module.exports = __webpack_public_path__ + "static/media/partitionSubImg1.5a9630f8.png";